import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { Options } from '@angular-slider/ngx-slider/options';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';
import { QRInput } from 'src/app/models/qr-input.model';
import {
  OfficeTotalList,
  RankingOffice,
  RankingOfficeRegion,
  RankingOfficeSubregion,
} from 'src/app/models/ranking-office.model';
import { QRChip } from 'src/app/models/qr-chip.model';

export interface RankingRegionStatus {
  id: number | undefined;
  value: string | undefined;
  status: boolean;
}
@Component({
  selector: 'app-filter-ranking',
  templateUrl: './filter-ranking.component.html',
  styleUrls: ['./filter-ranking.component.scss'],
})
export class FilterRankingComponent {
  @Output() filterVisible: EventEmitter<[any]> = new EventEmitter<[any]>();
  @Output() rangesChange: EventEmitter<number[][]> = new EventEmitter<
    number[][]
  >();
  @Output() subregionsChange: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();
  @Output() officeChange: EventEmitter<number[]> = new EventEmitter<number[]>();
  @Input() data: RankingOffice[] = [];
  @Input() loadedData: boolean | undefined;
  @Input() subregions: RankingOfficeSubregion[] = [];
  @Input() officeList: OfficeTotalList[] = [];
  listAutocompleteOffices: string[] = [];
  officesSelected: string[] = [];
  rangesFilter = [
    [0, 0],
    [0, 0],
  ];

  math = Math;

  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  subregionMultiple: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: ['Opción 1', 'Opción 2', 'Opción 3', 'Opción 4'],
    isMultiple: true,
  };

  // ----- Botones de región ------
  @Input() regions: RankingOfficeRegion[] = [];
  @Output() regionsChange: EventEmitter<RankingRegionStatus[]> =
    new EventEmitter<RankingRegionStatus[]>();
  regionsButtons: QRButton[] = [];

  rangesViewAnt = false;
  rangesViewAgent = false;

  // -----  Rangos Antigüedad oficina -----
  antiquityOfficeFromValue = 0; // Desde
  antiquityOfficeToValue = 25; // Hasta
  antiquityOfficeSliderOptions: Options = {
    floor: 0, // Rango mínimo
    ceil: 25, // Rango máximo,
    hidePointerLabels: false,
    hideLimitLabels: true,
  };

  // ----- Rangos Cantidad agentes -----
  amountAgentsFromValue = 1; // Desde
  amountAgentsToValue = 100; // Hasta
  amountAgentsSliderOptions: Options = {
    floor: 1, // Rango mínimo
    ceil: 100, // Rango máximo,
    hidePointerLabels: false,
    hideLimitLabels: true,
  };

  // ----- Input autocomplete Oficinas -----
  inputAutocompleteOffices: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Oficina',
    isCleanButtonVisible: true,
    options: ['option 1', 'option 2'],
  };

  listSubregions: string[] = [];

  // TODO: recheckear el any
  listSubregionsSelected: string | string[] | undefined | any = [];

  chipOffice: QRChip = {
    hierarchy: QRChip.HIERARCHY_2,
    size: QRChip.SIZE_SMALL,
    isCleanButtonVisible: true,
  };

  ngOnChanges() {
    this.rangesViewAgent = false;
    this.rangesViewAnt = false;
    this.listAutocompleteOffices = [];

    //Carga data general
    if (this.data && this.loadedData) {
      setTimeout(() => {
        this.calculateMaxMinRange();
      }, 700);
    }

    //Carga regiones
    if (this.regions.length > 0 && this.regionsButtons.length == 0) {
      this.regions.forEach((region: RankingOfficeRegion) => {
        const button: QRButton = {
          hierarchy: QRButton.HIERARCHY_2,
          size: QRButton.SIZE_SMALL,
          viewValue: region.region,
          id: region.regionId,
        };
        this.regionsButtons.push(button);
      });
    }

    //Carga subregiones
    if (this.loadedData && this.subregions) {
      this.generateListSubregions();
      this.listSubregionsSelected = this.listSubregions;
      this.onSubregionsChange(this.listSubregionsSelected);
    }

    //Carga lista de oficinas
    if (this.loadedData && this.officeList) {
      this.officeList.forEach((e) => {
        this.pushItem(e.name, this.listAutocompleteOffices);
      });
      this.inputAutocompleteOffices = {
        ...this.inputAutocompleteOffices,
        options: this.listAutocompleteOffices,
      };
      this.inputAutocompleteOffices.options = [...this.listAutocompleteOffices];
    }
  }

  // TODO: fix anys
  // push item si no existe
  pushItem(text: any, array: any) {
    const item: any = text;
    let exists = false;

    array.forEach((e: any) => {
      if (e == text) {
        exists = true;
      }
    });

    if (!exists) {
      array.push(item);
    }
  }

  generateListSubregions() {
    this.listSubregions = [];
    this.regionsButtons.forEach((region) => {
      if (region.hierarchy == QRButton.HIERARCHY_2) {
        this.subregions.forEach((e) => {
          if (e.subregion && e.mainRegion == region.id) {
            this.pushItem(e.subregion, this.listSubregions);
          }
        });
      }
    });

    this.subregionMultiple = {
      ...this.subregionMultiple,
      options: this.listSubregions,
    };
  }

  onSubregionsChange(selected: string | string[] | undefined): void {
    this.listSubregionsSelected = selected;
    this.listSubregionsSelected = [...this.listSubregionsSelected];

    //Formateo para emitir
    let list: number[] = [];
    this.listSubregionsSelected.forEach((selectedSubregion: string) => {
      this.subregions.forEach((s) => {
        if (selectedSubregion == s.subregion) {
          list.push(s.regionId);
        }
      });
    });
    this.officesSelected = [];
    this.officesSelected = [];
    this.subregionsChange.emit(list);
  }

  emitCloseFilter() {
    this.filterVisible.emit();
  }

  toggleRegion(id: number) {
    if (this.regionsButtons[id].hierarchy == QRButton.HIERARCHY_3) {
      this.regionsButtons[id] = {
        ...this.regionsButtons[id],
        hierarchy: QRButton.HIERARCHY_2,
      };
    } else {
      this.regionsButtons[id] = {
        ...this.regionsButtons[id],
        hierarchy: QRButton.HIERARCHY_3,
      };
    }

    this.generateListSubregions();

    //cuando saco y agrego regiones, debe agregarse sus subregiones ya seleccionadas o sacarlas de la lista de seleccionadas
    if (this.regionsButtons[id].hierarchy == QRButton.HIERARCHY_2) {
      this.subregions.forEach((e) => {
        if (e.mainRegion && e.mainRegion == this.regionsButtons[id].id) {
          if (e.subregion) {
            this.pushItem(e.subregion, this.listSubregionsSelected);
          }
        }
      });
    } else if (this.regionsButtons[id].hierarchy == QRButton.HIERARCHY_3) {
      this.subregions.forEach((s) => {
        if (s.mainRegion && s.mainRegion == this.regionsButtons[id].id) {
          this.listSubregionsSelected = this.listSubregionsSelected.filter(
            (e: string) => e != s.subregion
          );
        }
      });
    }

    this.listSubregionsSelected = [...this.listSubregionsSelected];
    this.onSubregionsChange(this.listSubregionsSelected);
  }

  //Calcular maximos y minimos para filtro de rangos
  calculateMaxMinRange() {
    let minAntiguedad = 0;
    let minAgentes = 0;
    let maxAntiguedad = 0;
    let maxAgentes = 0;
    let arrayAntiguedad: number[] = [];
    let arrayAgentes: number[] = [];

    if (this.data.length > 0) {
      this.data.forEach((e) => {
        arrayAntiguedad.push(e.antiguedadOficina);
      });

      this.data.forEach((e) => {
        arrayAgentes.push(e.cantidadAgentesMensuales);
      });

      minAntiguedad = Number((Math.min(...arrayAntiguedad) / 365).toFixed());
      maxAntiguedad = Math.ceil(Math.max(...arrayAntiguedad) / 365);

      minAgentes = Math.min(...arrayAgentes);
      maxAgentes = Math.max(...arrayAgentes);

      this.antiquityOfficeFromValue = minAntiguedad;
      this.antiquityOfficeToValue = maxAntiguedad;
      this.antiquityOfficeSliderOptions.floor = minAntiguedad;
      this.antiquityOfficeSliderOptions.ceil = maxAntiguedad;

      this.amountAgentsFromValue = minAgentes;
      this.amountAgentsToValue = maxAgentes;
      this.amountAgentsSliderOptions.floor = minAgentes;
      this.amountAgentsSliderOptions.ceil = maxAgentes;

      if (
        this.antiquityOfficeFromValue == 0 &&
        this.antiquityOfficeToValue == 0
      ) {
        this.rangesViewAnt = false;
      } else {
        this.rangesViewAnt = true;
      }

      if (this.amountAgentsFromValue == 0 && this.amountAgentsToValue == 0) {
        this.rangesViewAgent = false;
      } else {
        this.rangesViewAgent = true;
      }

      this.rangesFilter[0][0] = minAntiguedad;
      this.rangesFilter[0][1] = maxAntiguedad;
      this.rangesFilter[1][0] = minAgentes;
      this.rangesFilter[1][1] = maxAgentes;
    }
  }

  // Rango - Desde y hasta Antigüedad oficina
  rangeFromOfficeYears(value: number) {
    this.rangesFilter[0][0] = value;
    this.onEmitRange();
  }
  rangeToOfficeYears(value: number) {
    this.rangesFilter[0][1] = value;
    this.onEmitRange();
  }

  // Rango - Desde y Hasta Cantidad de agentes
  rangeFromAgents(value: number) {
    this.rangesFilter[1][0] = value;
    this.onEmitRange();
  }
  rangeToAgents(value: number) {
    this.rangesFilter[1][1] = value;
    this.onEmitRange();
  }

  onEmitRange() {
    this.officesSelected = [];
    setTimeout(() => {
      this.rangesChange.emit(this.rangesFilter);
    }, 1000);
  }

  removeString(array: string[], text: string): string[] {
    let list = array.filter(function (e: string) {
      return e != text;
    });
    return list;
  }

  emitOffice() {
    let list: number[] = [];
    this.officesSelected.forEach((e) => {
      this.officeList.forEach((elem) => {
        if (elem.name == e) {
          this.pushItem(elem.agencyId, list);
        }
      });
    });
    this.officeChange.emit(list);
  }

  inputAutocompleteChange(value: string | undefined): void {
    if (value) {
      this.pushItem(value, this.officesSelected);
      this.listAutocompleteOffices = [
        ...this.removeString(this.listAutocompleteOffices, value),
      ];

      this.emitOffice();
    }
  }

  cleanChip(e: string | number): void {
    if (e && typeof e == 'string') {
      this.officesSelected = this.removeString(this.officesSelected, e);
      this.emitOffice();
    }
  }
}
